var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          staticClass: "flowing-water-dialog",
          attrs: {
            title: "流水详情",
            width: "700px",
            visible: _vm.dialogVisible
          },
          on: { close: _vm.close }
        },
        [
          _c("div", { staticClass: "flowing-water-detail-wrapper" }, [
            _c("div", { staticClass: "flowing-water-content" }, [
              _c("div", { staticClass: "flowing-item" }, [
                _c("span", [_vm._v("承运方：")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.details.carrier))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flowing-item" }, [
                _c("span", [_vm._v("流水号：")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.details.runningNo))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flowing-item" }, [
                _c("span", [_vm._v("账单号：")]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "link-url", on: { click: _vm.goBillDetail } },
                  [_vm._v(_vm._s(_vm.details.billNo))]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flowing-item" }, [
                _c("span", [_vm._v("收付类型：")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.details.receiptAndPaymentType))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flowing-item" }, [
                _c("span", [_vm._v("收款方式：")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      {
                        1: "油卡",
                        2: "网银",
                        3: "现金",
                        4: "支付宝",
                        5: "微信",
                        6: "电汇",
                        7: "支票",
                        8: "承兑"
                      }[_vm.details.method]
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flowing-item" }, [
                _c("span", [_vm._v("金额：")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.details.totalMoney))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flowing-item" }, [
                _c("span", [_vm._v("生成时间：")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm._f("timeFormat")(_vm.details.createTime)))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("投诉")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("complaint-dialog", {
            attrs: {
              dialogVisible: _vm.complaintVisible,
              content: _vm.details.runningNo
            },
            on: {
              "update:dialogVisible": function($event) {
                _vm.complaintVisible = $event
              },
              "update:dialog-visible": function($event) {
                _vm.complaintVisible = $event
              },
              close: _vm.close
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-646e28af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-646e28af","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/flowingWater/components/flowingWaterTable/components/detailDialog/index.vue
// module id = null
// module chunks = 